import { prop } from 'ramda';
import React from 'react';
import { useParams } from 'react-router-dom';

import useFetchAssessmentQuestionGroups from 'App/hooks/useFetchAssessmentQuestionGroups';
import { NumberField } from 'Shared/form/NumberField';
import SelectField from 'Shared/form/SelectField';
import assessmentSettingsPropType from '../../types/assessmentSettings';
import { noGroupOption } from '../constants';
import questionPropType from '../types/questionPropType';
import QuestionAccordionWrapper from './QuestionAccordionWrapper';
import QuestionBlockedDaysField from './QuestionBlockedDaysField';
import QuestionLinkingField from './QuestionLinkingField';
import QuestionOptionsField from './QuestionOptionsField';
import QuestionScoringField from './QuestionScoringField';

const QuestionAttributesSection = ({ question, assessment }) => {
    const { parentAnswerId } = useParams();
    const { data: questionGroups = {}, isLoading: isQuestionGroupsLoading } = useFetchAssessmentQuestionGroups();

    const questionGroupOptions = React.useMemo(() => {
        return [noGroupOption, ...Object.values(questionGroups).sort((a, b) => a.groupOrder - b.groupOrder)];
    }, [questionGroups]);

    return (
        <QuestionAccordionWrapper
            questionId={question.question_id}
            statePath="sections.attributes"
            title="Attributes"
            headerClassName="assessment-manager-question-section-header"
        >
            <div>
                {!parentAnswerId && (
                    <SelectField
                        fieldName={`questions.${question.question_id}.group`}
                        label="Question Group"
                        options={questionGroupOptions}
                        isLoading={isQuestionGroupsLoading}
                        getOptionLabel={prop('name')}
                        getOptionValue={prop('id')}
                    />
                )}

                <NumberField
                    fieldName={`questions.${question.question_id}.attributes.position`}
                    label="Question Position"
                    placeholder="Question Position"
                    debounce
                />

                <QuestionOptionsField question={question} assessment={assessment} />

                <QuestionBlockedDaysField question={question} />

                <QuestionScoringField question={question} />

                <QuestionLinkingField question={question} />
            </div>
        </QuestionAccordionWrapper>
    );
};

QuestionAttributesSection.propTypes = {
    question: questionPropType.isRequired,
    assessment: assessmentSettingsPropType.isRequired,
};

export default React.memo(QuestionAttributesSection);
